import { Form, Modal } from "react-bootstrap";
import LoadingSpinner from "../../../Components/Components/LoadingSpinner";
import { useTranslation } from "react-i18next";

const ChangeOrderNumberModal = ({ isChangeNameVisible, handleCancelButtonClick, isSaving, custOrderNumber, handleEditName, handleSave, error }) => {
    const { t } = useTranslation()

    return (
        <Modal size='md' show={isChangeNameVisible} onHide={handleCancelButtonClick} centered >
            <Modal.Header closeButton>
                <Modal.Title>Zmiana numeru zamówienia</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isSaving ? (<LoadingSpinner />) : (<>
                    <div className="cont profile-details-info">
                        <div className="row data-container">
                            <div className='col'>
                                <Form.Control autoFocus={true} maxLength={20} name='custOrderNumber' placeholder={'Własna nazwa zlecenia'} value={custOrderNumber} onChange={handleEditName} required />
                            </div>
                        </div>
                        <div className="row data-container mt-4">
                            <div className="col d-grid">
                                <button className='btn-app-primary' onClick={handleSave}>
                                    {t("confirm")}
                                </button>
                            </div>
                        </div>
                    </div>
                    {error.length > 0 ? (<div className="row error-text-color justify-content-center mb-4">{error}</div>) : (<></>)}</>)}
            </Modal.Body>
        </Modal>
    )
}

export default ChangeOrderNumberModal